import React from 'react';
import documents from '../../assets/document/documents.png';
import "./noDocument.css";
import { useTranslation } from 'react-i18next'; 


function NoDocument() {
  const { t } = useTranslation();
  return (
      <div className="up">
        
        <div className="up-container">
         <div>
         <p className="up-text1">{t('documents.noDocumentsAvailable')}</p>
         
                <img src={documents} alt=""/>
            </div>
        </div>
    </div>
    
  );
}
export default NoDocument;